import { apiRequest } from './client';
import type { AdminAccount, AdminSession } from '../types';

export function loginAdmin(username: string, password: string) {
  return apiRequest<{ success: boolean; token: string; username: string }>('/api/admin/login', {
    method: 'POST',
    body: { username, password },
  });
}

export function fetchAdminSession() {
  return apiRequest<AdminSession>('/api/admin/session', { auth: true });
}

export function logoutAdmin() {
  return apiRequest<{ success: boolean }>('/api/admin/logout', { method: 'POST', auth: true });
}

export function fetchAdminAccounts() {
  return apiRequest<AdminAccount[]>('/api/admin/accounts', { auth: true });
}

export function createAdminAccount(username: string, password: string) {
  return apiRequest<AdminAccount>('/api/admin/accounts', {
    method: 'POST',
    auth: true,
    body: { username, password },
  });
}

export function deleteAdminAccount(id: number) {
  return apiRequest<{ success: boolean }>(`/api/admin/accounts/${id}`, {
    method: 'DELETE',
    auth: true,
  });
}
